import type { ApiApplicationDetails } from 'types/Application'
import { Item } from '../DetailsList'
import { DetailsRow } from './details-row'
import { useTranslation } from 'react-i18next'
import { renderDate } from 'utils/renderDate'

export const TechnicalData = ({ data }: { data: ApiApplicationDetails }): JSX.Element => {
  const { t } = useTranslation()

  return (
    <DetailsRow
      title={t('application.technicalApplicationData')}
      description="Application history and other informations"
    >
      {[
        data.application_id ? (
          <Item key="application_id" label={t('application.id')} text={data.application_id} />
        ) : null,
        data.application_createdAt ? (
          <Item
            key="application_createdAt"
            label={t('common.createdAt')}
            text={renderDate(data.application_createdAt, true)}
          />
        ) : null,
        data.application_createdAtLocal ? (
          <Item
            key="application_createdAtLocal"
            label={`${t('common.createdAt')} local`}
            text={renderDate(data.application_createdAtLocal, true)}
          />
        ) : null,
        data.application_verifiedAtLocal ? (
          <Item
            key="application_verifiedAtLocal"
            label={`${t('common.verifiedAt')} local`}
            text={renderDate(data.application_verifiedAtLocal, true)}
          />
        ) : null,
        <Item
          key="application_createdById"
          label={t('common.createdBy')}
          text={data.application_createdById === 1 ? t('application.system') : data.application_createdById}
        />,
        data.application_updatedById !== 1 ? (
          <Item key="application_updatedAt" label={t('common.updatedAt')} text={data.application_updatedAt} />
        ) : null,
        data.application_updatedById !== 1 ? (
          <Item key="application_updatedById" label={t('common.updatedBy')} text={data.application_updatedById} />
        ) : null,
        data.application_ipAddress ? (
          <Item
            key="application_ipAddress"
            label={t('application.ip')}
            text={data.application_ipAddress.length > 0 ? data.application_ipAddress : 'N/A'}
          />
        ) : null,
      ].filter(el => el !== null)}
    </DetailsRow>
  )
}
